<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-27 00:50:40
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 02:10:20
-->
<template>
  <div class="bidItem">
    <div class="inner">
      <div class="shiptit">
        <span>{{ info.bizName || "--" }}</span>
        <span
          ><span class="color6">船名：</span>{{ info.shipName || "--" }}</span
        >
      </div>
      <div class="cenli" v-if="info.state == 1">
        <span style="margin-right: 10px">{{ info.shipowner || "--" }}</span>
        <span>{{ info.shipownerPhone || "--" }}</span>
      </div>
      <div class="cenli" v-if="info.state == 2">
        <span
          ><span class="color6">派单时间：</span
          >{{ info.distributeTime || "--" }}</span
        >
      </div>
      <div class="cenli" v-if="info.state == 2">
        <span
          ><span class="color6">登记时间：</span
          >{{ info.submitTime || "--" }}</span
        >
      </div>
    </div>
    <div class="type">
      <div v-if="info.state == 1">
        <span
          ><span class="color6">派单时间：</span
          >{{ info.distributeTime || "--" }}</span
        >
      </div>
      <div class="type2" v-if="info.state == 1" @click="registration">
        维修登记
      </div>
      <div v-if="info.state == 2" style="color: #3db0fc">
        {{ info.type == 1 ? "维修设备" : info.type == 2 ? "更换设备" : "--" }}
      </div>

      <div class="type2" v-if="info.state == 2" @click="oninfo">查看</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "bidItem",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  //  1,待接单,2 退回状态  3 已接单  4 已指派  5 已打卡 6 已完单
  data() {
    return {
      tableList: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    registration() {
      this.$router.push({
        path: "/workOrder/repair/register",
        query: {
          id: this.info.id,
        },
      });
    },
    oninfo() {
      this.$router.push({
        path: "/workOrder/repair/registerInfo",
        query: {
          id: this.info.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bidItem {
  width: 96%;
  // min-height: 200px;
  background: #ffffff;
  border-radius: 10px;
  margin: 0 auto 10px;
  padding: 0 15px;
  .inner {
    padding: 15px 0 0;
    font-size: 14px;
    color: #333;
    .color6 {
      color: #666;
    }
    .shiptit {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .cenli {
      margin: 10px 0;
    }
  }
  .type {
    border-top: 1px solid #eeeeee;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // text-align: right;
    color: #333;
    font-size: 14px;
    .color6 {
      color: #666;
    }

    .type2 {
      display: inline-block;
      padding: 0 15px;
      height: 26px;
      background: #3db0fc;
      border: 1px solid #44b1f9;
      border-radius: 5px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      font-weight: 500;
      text-align: center;
      color: #fff;
      line-height: 26px;
      margin-right: 5px;
    }
  }
}
</style>